import styled from 'styled-components';
import SectionContainer from '@common/components/SectionContainer';

export const HeaderWrapper = styled(SectionContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  justify-content: flex-start;
`;

export const CenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  justify-content: flex-end;
`;
